import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import check from "../../assets/check.png";
import more from "../../assets/more.svg";
import { updateLevel1, updateLevel5 } from "../../store/QuestionnaireSlice";
import editPen from "../../assets/edit_pen.svg";
import trash from "../../assets/trash.svg";
import { useRef } from "react";

const Level1 = forwardRef(
  ({ onNext, placement, editError, setEditError }, ref) => {
    const dispatch = useDispatch();
    const segments = useSelector((state) => state.questionnaire.level1Data);
    const questions = useSelector((state) => state.questionnaire.questions);
    const level5Data = useSelector((state) => state.questionnaire.level5Data);
    const inputRef = useRef(null);

    const [newSegmentTitle, setNewSegmentTitle] = useState("");
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [editingIndex, setEditingIndex] = useState(null);
    const [editSegmentTitle, setEditSegmentTitle] = useState("");
    const [error, setError] = useState("");

    useImperativeHandle(ref, () => ({
      handleNextClick,
    }));

    const handleAddSegment = () => {
      if (newSegmentTitle.trim()) {
        dispatch(
          updateLevel1([...segments, { _id: "", name: newSegmentTitle }])
        );
        setNewSegmentTitle("");
      }
      console.log(segments);
      inputRef.current?.focus();
    };

    const handleDeleteSegment = (index) => {
      const updatedSegments = segments.filter((_, i) => i !== index);
      dispatch(updateLevel1(updatedSegments));
      setActiveDropdown(null);
    };

    const handleEditSegment = (index) => {
      setEditingIndex(index);
      setEditSegmentTitle(segments[index].name);
      setActiveDropdown(null);
    };

    const handleUpdateSegment = (index, newValue) => {
      if (newValue.trim()) {
        console.log(level5Data);
        const updatedLevel5Data = [...level5Data];
        const updatedSegments = [...segments];
        for (let i = 0; i < level5Data.length; i++) {
          if (updatedLevel5Data[i].product === updatedSegments[index].name) {
            console.log(newValue);
            updatedLevel5Data[i] = {
              ...updatedLevel5Data[i],
              product: newValue,
            };
          }
        }
        console.log(updatedLevel5Data);
        updatedSegments[index] = { ...updatedSegments[index], name: newValue };
        dispatch(updateLevel1(updatedSegments));
        dispatch(updateLevel5(updatedLevel5Data));
        setEditingIndex(null);
        setEditSegmentTitle("");
      } else {
        setError("Segment title cannot be empty");
        setEditingIndex(null);
        return "Segment title cannot be empty";
      }
    };

    const handleNextClick = () => {
      // alert("running");
      if (newSegmentTitle) {
        if (newSegmentTitle.trim()) {
          dispatch(
            updateLevel1([...segments, { _id: "", name: newSegmentTitle }])
          );
          setNewSegmentTitle("");
        }
      }
      if (segments.length === 0 && !newSegmentTitle) {
        setError("Please add at least one segment from level 1");
        return "Please add at least one segment from level 1";
      }
      for (let i = 0; i < segments.length; i++) {
        if (segments[i].name.trim() === "") {
          setError("Segment title cannot be empty");
          return "Segment title cannot be empty";
        }
      }
      if (onNext) {
        onNext();
      }
    };

    // Close dropdown when clicking outside
    useEffect(() => {
      const handleClickOutside = () => setActiveDropdown(null);
      document.addEventListener("click", handleClickOutside);
      return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    return (
      <>
        <div
          className={` pb-6 px-10 mx-auto rounded-lg max-w-[1200px] ${
            placement !== "edit" ? "bg-[#F4F5F6] pt-[30px]" : "bg-white"
          }`}
        >
          <div>
            <div className="bg-[#1C3F3A] max-w-[60px] max-h-[27px] px-[10px] py-[6px] text-white rounded-md text-[12px]">
              {questions?.level || "Level 1"}
            </div>
            <p
              className={`mt-3 mb-6 font-medium ${
                placement === "edit" ? "text-[1.125rem]" : "text-[1.25rem]"
              }`}
            >
              {questions[0]?.description ||
                "Please indicate the primary operating segments within your company which you currently track"}
            </p>
            {(error || editError) && (
              <p className="flex justify-between items-center bg-red-100 border-l-2 border-0 mb-5 border-red-400 text-red-700 px-4 py-3">
                {error ? error : editError}
                <span
                  className="cursor-pointer"
                  onClick={() => {
                    if (editError) {
                      setEditError("");
                    } else {
                      setError("");
                    }
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 26 26"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={1}
                      d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </span>
              </p>
            )}
            <div className="">
              <div className="flex flex-wrap gap-2.5 gap-y-5 mb-4">
                {segments.map((segment, index) =>
                  editingIndex === index ? (
                    <div className="max-w-[210px]">
                      <input
                        type="text"
                        value={editSegmentTitle}
                        onChange={(e) => setEditSegmentTitle(e.target.value)}
                        onBlur={() =>
                          handleUpdateSegment(index, editSegmentTitle)
                        }
                        onKeyPress={(e) => {
                          if (e.key === "Enter") {
                            handleUpdateSegment(index, editSegmentTitle);
                          }
                        }}
                        className="px-[0.75rem] py-[0.325rem] w-full border border-[#D9D9D9] rounded-lg focus:outline-none"
                        autoFocus
                      />
                    </div>
                  ) : (
                    <div
                      key={index}
                      className="flex items-center justify-between px-[0.75rem] py-[0.325rem] min-w-[210px] h-fit bg-white rounded-lg shadow-sm border border-[#D9D9D9]"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleEditSegment(index);
                      }}
                    >
                      {/* {editingIndex === index ? (
                    ) : (
                      <> */}
                      <span className="font-[500] mr-2">{segment.name}</span>
                      <div className="relative flex">
                        <button
                          className="text-gray-400"
                          // onClick={(e) => {
                          //   e.stopPropagation();
                          //   setActiveDropdown(
                          //     activeDropdown === index ? null : index
                          //   );
                          // }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteSegment(index, segment);
                          }}
                        >
                          <img src={trash} alt="" className="" />
                        </button>
                        {/* {activeDropdown === index && (
                          <div className="absolute right-0 mt-2 w-[140px] bg-white rounded-[10px] shadow-lg border border-gray-200 z-50">
                            <button
                              className="w-full text-sm px-4 py-1.5 text-left border-b border-[#D9D9D9] hover:bg-gray-100 flex items-center gap-2"
                              onClick={() => handleEditSegment(index)}
                            >
                              <img src={editPen} alt="" className="" />
                              Edit
                            </button>
                            <button
                              className="w-full text-sm px-4 py-1.5 text-left hover:bg-gray-100 flex items-center gap-2"
                              onClick={() =>
                                handleDeleteSegment(index, segment)
                              }
                            >
                              <img src={trash} alt="" className="" />
                              Delete
                            </button>
                          </div>
                        )} */}
                      </div>
                      {/* </>
                    )} */}
                    </div>
                  )
                )}

                {/* Rest of the code remains the same */}
                <div className="relative w-[210px]">
                  <input
                    ref={inputRef}
                    type="text"
                    value={newSegmentTitle}
                    onChange={(e) => setNewSegmentTitle(e.target.value)}
                    placeholder="Enter Segment Title"
                    className="px-4 py-[0.325rem] w-full border border-[#D9D9D9] rounded-[6px] focus:outline-none"
                    onKeyPress={(e) => {
                      if (e.key === "Enter") {
                        handleAddSegment();
                      }
                    }}
                    autoFocus
                  />
                  <img
                    src={check}
                    alt=""
                    className="absolute right-3 top-3 max-sm:hidden"
                  />
                </div>

                <button
                  onClick={handleAddSegment}
                  className="relative py-[0.375rem] w-[210px] h-fit font-medium rounded-[6px] text-[#1C3F3A] hover:bg-[#f0f0f0] transition-colors"
                >
                  <svg
                    width="100%"
                    height="100%"
                    viewBox="0 0 210 36"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="absolute inset-0"
                    preserveAspectRatio="none"
                  >
                    <rect
                      x="0.5"
                      y="0.5"
                      width="99%"
                      height="97%"
                      rx="5.5"
                      fill="white"
                      stroke="#1C3F3A"
                      strokeWidth="1"
                      strokeDasharray="4 4"
                    />
                  </svg>
                  <span className="relative z-10">Add New Segment</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        {placement !== "edit" && (
          <div className="flex justify-end mt-[26px]">
            <button
              className="px-5 py-3.5 flex gap-4 bg-[#55C880] text-white rounded-[10px] "
              onClick={handleNextClick}
            >
              <span className="">Next</span>
              <span className="">→</span>
            </button>
          </div>
        )}
      </>
    );
  }
);

export default Level1;
